import React from 'react';
import { Button } from 'reactstrap';

const EditIconButton = ({ ...props }) => (
  <Button color="primary" outline {...props}>
    <i className="fa fa-pencil text-warning" />
  </Button>
);

EditIconButton.propTypes = {
  ...Button.propTypes,
};

export { EditIconButton };
